<cw-card-list [title]="'DASHBOARD.LAST_OPENED_PROJECTS_SITES'" [elements]="cardElements" [msgError]="msgError"
    [isLoading]="isLoading" (clickElement)="onClickElement($event)">
</cw-card-list>